// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"845":"profile","976":"tool"}[chunkId] || chunkId) + "." + {"541":"40963c49","845":"388e39c4","976":"8492997f"}[chunkId] + ".css";
};